import { createStore } from 'vuex'

const URL = 'https://server-web.konaweselatankab.go.id/';
const URL_SIMPEG = 'https://server-egov.konaweselatankab.go.id/';

export default createStore({
  state: {
    url: {
      URL_APP_SIMPEG: URL_SIMPEG, 
      URL_APP: URL,
      URL_SLIDER: URL + 'api/v1/publish_dtphp_slider/',
      URL_BERITA: URL + 'api/v1/web_publish_berita/',
      URL_SAMBUTAN: URL + 'api/v1/publish_dtphp_sambutan/',
      URL_LINK_TERKAIT: URL + 'api/v1/web_publish_link_terkait/',
      URL_FOTO: URL + 'api/v1/publish_dtphp_foto/',
      URL_DATA_PEGAWAI: URL + 'api/v1/publish_dtphp_data_pegawai/',
      URL_TUGAS_POKOK: URL + 'api/v1/publish_dtphp_tugas_pokok/',
      URL_VISI_MISI: URL + 'api/v1/publish_dtphp_visi_misi/',
      URL_STRUKTUR_ORGANISASI: URL + 'api/v1/publish_dtphp_struktur_organisasi/',
      URL_UNIT_KERJA: URL + 'api/v1/publish_dtphp_unit_kerja/',
      URL_PRODUKSI_BENIH: URL + 'api/v1/publish_dtphp_produksi_benih/',
      URL_DOKUMEN: URL + 'api/v1/publish_dtphp_dokumen/',
      URL_FOTO: URL + 'api/v1/publish_dtphp_foto/',
      URL_VIDEO: URL + 'api/v1/publish_dtphp_video/',

      //   const URL_SLIDER = URL_APP + "api/v1/publish_dtphp_slider/";
      // const SAMBUTAN_URL = URL_APP + "api/v1/publish_dtphp_sambutan/";
      // const ADD_URL_BERITA = URL_APP + "api/v1/web_publish_berita/";
      // const ADD_URL_FOTO = URL_APP + "api/v1/publish_dtphp_foto/";
      // const FILE_LOAD = URL_APP + "uploads/";
      // const ADD_URL_LINK_TERKAIT = URL_APP + "api/v1/web_publish_link_terkait/";
    },
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
